'use client';
import React, { useState } from 'react';
import { useCart } from '@/lib/hooks/useCart';
import { CartButton as SharedCartButton } from '@launchstore/shared-puck';
import type { CartButtonProps } from '@launchstore/shared-puck';
import CartDrawer from '@/components/cart/CartDrawer';

/**
 * Storefront wrapper: derives cartCount from the storefront's
 * useCart hook. Click opens the storefront CartDrawer.
 *
 * For now uses the existing local CartDrawer; D-3 will move the
 * drawer into launchstore-shared as well.
 */
const SharedCartButtonRender = (SharedCartButton as any).render;

const CartButtonImpl: React.FC<CartButtonProps> = (props: any) => {
  const { cart } = useCart();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const count = (cart?.items || []).reduce((acc: number, it: any) => acc + (it.quantity || 0), 0);
  return (
    <>
      <SharedCartButtonRender {...(props as any)} cartCount={count} onOpenCart={() => setDrawerOpen(true)} />
      <CartDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
};

export const CartButton: any = { ...SharedCartButton, render: (props: any) => <CartButtonImpl {...props} /> };
export default CartButton;
